import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { LogListComponent } from './log-list/log-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'log',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [{ path: '', component: LogListComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LogsRoutingModule {}
